import { ApiService } from '@/api';
import { Notification } from '@/models';

export class NotificationsApi {
  private readonly baseUrl = '/api/notifications';

  public async getAll(): Promise<Notification[]> {
    const response = await ApiService.get(`${this.baseUrl}`);
    return response.json();
  }

  public async markAsRead(idList: string[]): Promise<void> {
    await ApiService.post(
      `${this.baseUrl}/read`,
      idList,
    );
  }
}
